






import {Component, Vue} from 'vue-property-decorator';
import MainLayout from './layouts/MainLayout.vue';
import AuthLayout from './layouts/AuthLayout.vue';
import PageNotFound from './views/PageNotFoundView.vue';
import ErrorLayout from './layouts/ErrorLayout.vue';
import PageNotFoundLayout from './layouts/PageNotFoundLayout.vue';
import enumsModule from './store/modules/enumsModule';

@Component({
  components: {
    MainLayout,
    AuthLayout,
    PageNotFound,
    ErrorLayout,
    PageNotFoundLayout,
  },
})
export default class App extends Vue {
  get layout() {
    if ((this.$route as any).meta.layout) return (this.$route as any).meta.layout + '-layout';
    else if (enumsModule.loaded)
      // TODO: нужен общий флаг того что все загружено
      return 'PageNotFound';
    return undefined;
  }
}
